import React, { Component } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import PersonalCenterLeftRender from './children/PersonalCenterLeftRender';
import PurchaseModal from './children/purchaseModal/PurchaseModal';
import Cookies from 'js-cookie';
import '@/views/account/assets/personalCenter.scss';
import cartUrl from '@/views/account/utils/cartUrl';

export default class PersonalCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseModalVisible: false, //购买弹窗显示控制变量
      headerUrl: '',
    };
  }

  componentDidMount() {
    //当用户没有登录认证的时候，跳出当前页面
    if (!Cookies.get('authorization')) {
      this.handleNavigationToLogin();
    }
    this.isAddCartParms();
  }
  /**
   * 跳转到登录
   */
  handleNavigationToLogin = () => {
    this.setState(
      {
        linkToLogin: true,
      },
      () =>
        this.setState({
          linkToLogin: false,
        })
    );
  };

  /**
   *控制购买弹窗出现和关闭
   * @param {Boolean} purchaseModalVisible
   */
  handlePurchaseModalVisible = (purchaseModalVisible) => {
    this.setState({
      purchaseModalVisible,
    });
  };

  //判断点击个人中心的头部，是否需要加上购物车参数
  isAddCartParms() {
    let urlParam = '';
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      urlParam = this.getUrlParam(location.href);
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      urlParam = obj;
    }
    const url = `track[type]=${urlParam['track[type]']}&track[sid]=${urlParam['track[sid]']}&track[func]=${urlParam['track[func]']}&track[reason]=${urlParam['track[reason]']}&track[host]=${urlParam['track[host]']}&track[platform]=${urlParam['track[platform]']}&track[ab]=${urlParam['track[ab]']}&track[channel]=${urlParam['track[channel]']}&track[discount]=${urlParam['track[discount]']}`;
    this.setState({
      headerUrl: url,
    });
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  render() {
    return (
      <>
        {this.state.linkToLogin && <Navigate to='/login' replace={true} />}
        <div className='personal-center-page'>
          <div
            className='lft position-md-sticky position-static pe-0'
            style={{
              marginRight: 32,
            }}
          >
            <PersonalCenterLeftRender
              headerUrl={this.state.headerUrl}
              handlePurchaseModalVisible={this.handlePurchaseModalVisible}
            />
          </div>
          <div className='rgt'>
            <Outlet />
          </div>
          {this.state.purchaseModalVisible && (
            <PurchaseModal
              visible={this.state.purchaseModalVisible}
              handleVisible={this.handlePurchaseModalVisible}
            />
          )}
        </div>
      </>
    );
  }
}
